export * from './ui-icon';
export type { UiIconProps } from './types';
